'use client';
import Button from '@/app/components/ui/Button';
import { useWhatsAppLink } from '@/app/hooks/useWhatsAppLink';

export default function ProcessSection() {
  const getWhatsAppLink = useWhatsAppLink();

  const handleDiagnostico = () => {
    const link = getWhatsAppLink();
    window.open(link, '_blank');
  }

  return (
    <section id="method" className="w-full bg-[#02020c] py-[51px] sm:py-[76px] lg:py-[102px]">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="bg-[#0528345b] border border-[#34505a] rounded-[24px] sm:rounded-[56px] lg:rounded-[112px] py-[40px] sm:py-[76px] lg:py-[102px] px-[20px] sm:px-[42px] lg:px-[56px]">
          <div className="flex flex-col items-center gap-[15px] sm:gap-[22px] lg:gap-[30px] w-full">
            {/* Section Header */}
            <h2 
              className="text-[22px] sm:text-[33px] lg:text-[44px] font-semibold leading-[25px] sm:leading-[37px] lg:leading-[50px] text-center text-[#ffffff] w-full"
              style={{ fontFamily: 'Raleway' }}
            >
              Como Transformamos Seu Comercial em uma Máquina de ROI Previsível 
            </h2>

            <p 
              className="text-[10px] sm:text-[15px] lg:text-[20px] font-normal leading-[13px] sm:leading-[19px] lg:leading-[26px] text-center text-[#ffffff] w-full"
              style={{ fontFamily: 'Raleway' }}
            >
              Não vendemos uma solução genérica. Criamos uma estratégia de IA sob medida para o SEU processo comercial, com implementação guiada e resultados mensuráveis desde o primeiro mês.
            </p>

            {/* Process Steps */}
            <div className="flex flex-col gap-8 lg:gap-12 w-full max-w-5xl">
              {/* Step 1 */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center w-full py-4 lg:py-8">
                <div className="flex items-center justify-start gap-6 lg:gap-8">
                  <span 
                    className="text-[32px] sm:text-[48px] lg:text-[64px] font-semibold italic leading-[38px] sm:leading-[57px] lg:leading-[76px] text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    01
                  </span>
                  <span 
                    className="text-[22px] sm:text-[33px] lg:text-[44px] font-semibold leading-[26px] sm:leading-[39px] lg:leading-[52px] text-left text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Diagnóstico Comercial Profundo
                  </span>
                </div>
                <p 
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-normal leading-[13px] sm:leading-[19px] lg:leading-[26px] text-left text-[#ffffff] w-full"
                  style={{ fontFamily: 'Raleway' }}
                >
                <span className="font-bold block mb-[5px]">Raio-X completo do seu processo de vendas</span>Mapeamento completo das oportunidades de implementação de IA que gerarão maior impacto no seu ROI.                </p>
              </div>

              {/* Step 2 */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-[18px] sm:gap-[27px] lg:gap-[36px] items-center w-full border-t border-b border-[#34505a] py-[26px] sm:py-[39px] lg:py-[52px]">
                <div className="flex items-center justify-start gap-[18px] sm:gap-[27px] lg:gap-[36px]">
                  <span 
                    className="text-[32px] sm:text-[48px] lg:text-[64px] font-semibold italic leading-[38px] sm:leading-[57px] lg:leading-[76px] text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    02
                  </span>
                  <span 
                    className="text-[22px] sm:text-[33px] lg:text-[44px] font-semibold leading-[26px] sm:leading-[39px] lg:leading-[52px] text-left text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Plano de Ação Personalizado
                  </span>
                </div>
                <p 
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-normal leading-[13px] sm:leading-[19px] lg:leading-[26px] text-left text-[#ffffff] w-full"
                  style={{ fontFamily: 'Raleway' }}
                >
                <span className="font-bold block mb-[5px]">Sua estratégia customizada de IA + Dashboard sob medida</span>Com base no diagnóstico, criamos um plano de ação 100% personalizada para sua realidade
                </p>
              </div>

              {/* Step 3 */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-[18px] sm:gap-[27px] lg:gap-[36px] items-center w-full py-[14px] sm:py-[21px] lg:py-[28px]">
                <div className="flex items-center justify-start gap-[18px] sm:gap-[27px] lg:gap-[36px]">
                  <span 
                    className="text-[32px] sm:text-[48px] lg:text-[64px] font-semibold italic leading-[38px] sm:leading-[57px] lg:leading-[76px] text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    03
                  </span>
                  <span 
                    className="text-[22px] sm:text-[33px] lg:text-[44px] font-semibold leading-[26px] sm:leading-[39px] lg:leading-[52px] text-left text-[#ffffff]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Execução & Go-Live
                  </span>
                </div>
                <p 
                  className="text-[10px] sm:text-[15px] lg:text-[20px] font-normal leading-[13px] sm:leading-[19px] lg:leading-[26px] text-left text-[#ffffff] w-full"
                  style={{ fontFamily: 'Raleway' }}
                >
                  <span className="font-bold block mb-[5px]">Implementação guiada com acompanhamento</span>Partimos para a ação com um processo estruturado: IA operando com máxima eficiência + time comercial focado em fechar vendas + você com visibilidade total dos números.
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <Button
              onClick={handleDiagnostico}
              text_font_size="text-lg"
              text_font_family="Raleway"
              text_font_weight="font-normal"
              text_line_height="leading-base"
              text_text_align="center"
              text_color="text-primary-background"
              fill_background_color="bg-button-primary"
              border_border_radius="rounded-[30px]"
              padding="py-[16px] px-[34px] pr-[56px]"
              className="italic flex items-center gap-[10px] hover:opacity-90 transition-opacity duration-200 group"
            >
              <span className="group-hover:text-[#02020c] transition-colors duration-200">QUERO CONHECER O MÉTODO D.P.E</span>
              <img 
                src="/images/img_group_84.svg" 
                alt="Arrow" 
                className="w-[22px] h-[22px] group-hover:invert transition-all duration-200" 
              />
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}